
const digest = '0982ccb4dd5c775b3db73d9136ee9f960bfb9d130d28af19fd7b308b81a0af9f';
const css = `._codeSnippet_arpso_1 {
  font-family: monospace;
  color: var(--theme-code-text, #d14);
  border: 1px solid var(--theme-primary-border, #e1e1e1);
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: var(--theme-secondary-background, #f7f7f7);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_arpso_1"};
export { css, digest };
  